import React, { createContext, useContext, useState } from 'react';

const MusicContext = createContext(undefined);

export const MusicProvider = ({ children }) => {
  const [isMusicActive, setIsMusicActive] = useState(false);

  const toggleMusic = () => {
    setIsMusicActive((prev) => !prev);
  };

  const enableMusic = () => {
    setIsMusicActive(true);
  };

  const disableMusic = () => {
    setIsMusicActive(false);
  };

  return (
    <MusicContext.Provider
      value={{
        isMusicActive,
        toggleMusic,
        enableMusic,
        disableMusic
      }}
    >
      {children}
    </MusicContext.Provider>
  );
};

export const useMusicContext = () => {
  const context = useContext(MusicContext);
  if (!context) {
    throw new Error('useMusicContext must be used within a MusicProvider');
  }
  return context;
};

export default MusicContext;
